import React, { useMemo, memo } from 'react'
import Standard from '../organisms/CenterCards/Standard'
import Premium from '../organisms/CenterCards/Large'
import { ZoneIds } from '../../domain/zoneIds'
import { isPremium } from '../../domain/center'
import { getProviderType } from '../../domain/center'
import AdminBarInfo from '../AdminTool/AdminBarInfo'
import { getThirdPartyReviews } from '../../domain/center'
import { CenterAlgolia, FeedMode, Kevel_Zone_Ids } from '@/types/models'
import { PrimaryFocus } from '@/domain/primaryFocus/constant'
import { isNonEmptyArray } from '@/utils/checks'
import { RefinementList } from '@/domain/search/types'
import { shouldShowDistanceLabel } from '@/domain/center/useCases/shouldShowDistanceLabel'
import { PageType } from '@/types/models/PageType.model'
import { Department } from '@/domain/department/department'
const FeedCenterCard = ({
  center,
  index,
  pageTitle,
  cardIndex,
  activeFacets,
  isAd = false,
  queryID,
  zoneId,
  isNearbyFeed = false,
  shouldDefaultRegionalize = false,
  currentRefinements,
  locationType,
  termFocus,
  refinementLocation,
  pageType,
  department = Department.Default,
  termFeedMode = FeedMode.DEFAULT
}: {
  center: CenterAlgolia
  index: number
  cardIndex: number
  pageTitle?: string
  activeFacets?: string[] | []
  isAd: boolean
  queryID: string
  isNearbyFeed: boolean
  shouldDefaultRegionalize?: boolean
  currentRefinements: Partial<RefinementList>
  highlighted_specializations?: string[] | []
  locationType: string
  termFocus: PrimaryFocus | ''
  zoneId: Kevel_Zone_Ids
  refinementLocation?: string | number
  pageType?: PageType
  department?: Department
  termFeedMode?: FeedMode
}) => {
  const feedZoneId = useMemo(
    () => zoneId || ZoneIds.FeedOtherZone,
    [isAd, zoneId]
  )

  if (isPremium(center)) {
    return (
      <div>
        <Premium
          {...center}
          cardIndex={cardIndex}
          isAd={isAd}
          locationLabel={center.location_label}
          price_label={center.price_label}
          description={center.short_description}
          key={center.slug}
          analyticsDashboard={center.analytics_dashboard}
          rankingInfo={center._rankingInfo || null}
          pageTitle={pageTitle}
          activeFacets={activeFacets}
          clickUrl={center.clickUrl || ''}
          impressionUrl={center.impressionUrl}
          price={center.price}
          thirdPartyReviews={getThirdPartyReviews(center)}
          zoneId={feedZoneId}
          pricing={center.price}
          showDistanceLabel={shouldShowDistanceLabel(center, isNearbyFeed)}
          providerType={getProviderType(center)}
          currentRefinements={currentRefinements}
          center={center}
          hasCertifications={isNonEmptyArray(center.certifications)}
          refinementLocation={refinementLocation}
          pageType={pageType}
          department={department}
          termFeedMode={termFeedMode}
        />
        <AdminBarInfo
          center={center}
          activeFacets={currentRefinements}
          zoneId={zoneId}
          position={cardIndex}
          locationType={locationType}
          termFocus={termFocus}
          pageType={pageType}
          searchState={currentRefinements}
        />
      </div>
    )
  }

  return (
    <div>
      <Standard
        className="hit"
        data-insights-object-id={center.slug}
        data-insights-position={cardIndex}
        key={center.slug}
        {...center}
        cardIndex={cardIndex}
        accepted_insurance={center.accepted_insurance}
        activeFacets={activeFacets}
        analyticsDashboard={center.analytics_dashboard}
        insurance_description={center.insurance_description}
        verify_insurance_link={center.verify_insurance_link}
        locationLabel={center.location_label}
        position={index}
        price_label={center.price_label}
        description={center.short_description}
        thumbnail={center.featured_image}
        rankingInfo={center._rankingInfo || null}
        pageTitle={pageTitle}
        showDistanceLabel={shouldShowDistanceLabel(center, isNearbyFeed)}
        thirdPartyReviews={getThirdPartyReviews(center)}
        locations={center.locations}
        __queryID={queryID}
        pricing={center.price}
        shouldDefaultRegionalize={shouldDefaultRegionalize}
        providerType={getProviderType(center)}
        zoneId={feedZoneId || ZoneIds.FeedOtherZone}
        currentRefinements={currentRefinements}
        center={center}
        refinementLocation={refinementLocation}
        hasCertifications={isNonEmptyArray(center.certifications)}
        department={department}
        termFeedMode={termFeedMode}
        pageType={pageType}
      />
      <AdminBarInfo
        center={center}
        activeFacets={currentRefinements}
        zoneId={zoneId}
        position={cardIndex}
        locationType={locationType}
        termFocus={termFocus}
        pageType={pageType}
        searchState={currentRefinements}
      />
    </div>
  )
}

export default memo(FeedCenterCard)
